/**
 * Route for `scaling-payouts-volume-breakpoints`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ScalingPayoutsVolumeBreakpointsPage } from "../features/scaling-payouts-volume-breakpoints/ScalingPayoutsVolumeBreakpointsPage";

export const scalingPayoutsVolumeBreakpointsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/scaling-payouts-volume-breakpoints",
	component: ScalingPayoutsVolumeBreakpointsPage,
});

export default scalingPayoutsVolumeBreakpointsRoute;
